export default import.meta.ROLLDOWN_FILE_URL_NCSFxC9yx2Eis7zw8aM1Rw